import type { ReactElement } from "react";
import { useMemo } from "react";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type { EmployeeHeadcount } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import { MAX_CHIPS_GROUP_AMOUNT } from "../../../constants";
import type FindEmployeeHeadcountFilter from "../../../models/EmployeeHeadcountFilter/EmployeeHeadcountFilter";

import { mappingValueToLabel } from "./utils/mappingValueToLabel";

const EmployeeHeadcountFilterResult = ({
    value,
    isExpanded,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindEmployeeHeadcountFilter>): ReactElement | null => {
    const handleRemove = (id: EmployeeHeadcount) => {
        const updatedValues = value?.filter((v) => v !== id);
        onFilterValueRemove?.(updatedValues);
        onFilterUpdate(updatedValues);
    };

    const chipItems = useMemo((): ChipItem[] | undefined => {
        return value?.map((item: string) => {
            return {
                id: item,
                text: mappingValueToLabel(item),
                chipStatus: onGetLifecycleStatus?.(item),
            };
        });
    }, [value, onGetLifecycleStatus]);

    if (!chipItems?.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemove}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default EmployeeHeadcountFilterResult;
